import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { StaticImage } from "gatsby-plugin-image";

const AWSCertificate = ({
    title = "Achieve cloud excellence with <span class='text-primary'>AWS-certified specialists</span>",
    sectionClass = "",
    // maindes="Test"  
}) => {

    const Certification1 = '../images/aws-consulting-certificate-1.png'
    const Certification2 = '../images/aws-consulting-certificate-2.png'
    const Certification3 = '../images/aws-consulting-certificate-3.png'

    return (
        <>
            <section className={`section ${sectionClass}`}>
                <Container className="py-5">
                    <Row className="align-items-center g-5">
                        <Col>
                            <h2 className="h3 mb-0" dangerouslySetInnerHTML={{ __html: title }} />
                            {/* <p className="lead mb-0">{maindes}</p> */}
                        </Col>
                        <Col xs="auto">
                            <Row className="align-items-center" xs={3}>
                                <Col>
                                    <StaticImage loading="lazy" src={Certification1} alt="Certification" width={240} height={240} />
                                </Col>
                                <Col>
                                    <StaticImage loading="lazy" src={Certification2} alt="Certification" width={240} height={240} />
                                </Col>
                                <Col>
                                    <StaticImage loading="lazy" src={Certification3} alt="Certification" width={240} height={240} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default AWSCertificate;
